import { GaParameterExclusionsTextArea } from "../ga-parameter-exclusions-text-area";
import ExcludeURLParamsImage from "../images/exclude-url-params.png";

export const GA3ParameterExclusions = (): JSX.Element => (
  <div className="ga3-parameter-exclusions">
    <h4 className="heading mx-0 mb-0 mt-0 font-weight-bold text-lg mb-2">
      For GA3
    </h4>
    <p className="text-md mb-2">
      Please add the following UTM parameters to <b>each View</b> for your brand
      on Google Analytics.
    </p>
    <GaParameterExclusionsTextArea className="mb-2" />
    <p className="text-lg font-weight-bold">Please add them here:</p>
    <img
      className="img-fluid"
      src={ExcludeURLParamsImage}
      alt="Google Analytics screen cap"
    />
  </div>
);
